import { api } from "../Apis/interceptor";

export const get = function (id, cust_id) {
  return api.get("/api/v1/getFramework/" + id + "/" + cust_id);
};

export const findFrom = function (client_id) {
  return api.get("/api/v1/frameworksfrom/" + client_id);
};

export const all = function (cust_id, page, sortBy, orderBy) {
  return api.get(
    "/api/v1/frameworks/" + cust_id + "/" + page + "/" + sortBy + "/" + orderBy
  );
};

export const filter = function (
  skip,
  limit,
  cust_id,
  pattern,
  sortBy,
  orderBy
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/frameworks_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      pattern: pattern,
      sortBy: sortBy,
      orderBy: orderBy,
    },
  });
};

export const getPageLike = function (pattern, cust_id, sortBy, orderBy) {
  return api.get(
    "/api/v1/frameworksLike/" +
      pattern +
      "/" +
      cust_id +
      "/" +
      sortBy +
      "/" +
      orderBy
  );
};

export const create = function (frameworkData) {
  return api.post("/api/v1/frameworks/", frameworkData);
};

export const update = function (id, cust_id, frameworkData) {
  return api.put("/api/v1/frameworks/" + id + "/" + cust_id, frameworkData);
};

export const deletecl = function (framework_id, client_id) {
  return api.get("/api/v1/client/" + framework_id + "/" + client_id);
};

//not used
export const delete1 = function (id) {
  return api.delete("/api/v1/frameworks/" + id);
};

export const getNext = function (id, cust_id) {
  return api.get("/api/v1/frameworkNext/" + id + "/" + cust_id);
};

export const getPrevious = function (id, cust_id) {
  return api.get("/api/v1/frameworkPrev/" + id + "/" + cust_id);
};

export const getSeq = function (cust_id) {
  return api.get("/api/v1/frameworkId/" + cust_id);
};

export const multiDelete = function (ids, cust_id) {
  return api.delete("/api/v1/frameworkMultiDelete", {
    params: {
      id: ids,
      cust_id: cust_id,
    },
  });
};

export const bySeqId = function (searchVal, cust_id, sortBy, orderBy) {
  return api.get(
    "/api/v1/frameworks/bySeqId/" +
      searchVal +
      "/" +
      cust_id +
      "/" +
      sortBy +
      "/" +
      orderBy
  );
};
export const updateContact = function (id, cust_id, clt_name, selectedTeam) {
  return api.put(
    "/api/v1/updateContact/" + id + "/" + cust_id + "/" + clt_name,
    selectedTeam
  );
};
export const addContact = function (
  id,
  cust_id,
  client_id,
  client_name,
  clientForm
) {
  return api.put(
    "/api/v1/addContact/" +
      id +
      "/" +
      cust_id +
      "/" +
      client_id +
      "/" +
      client_name,
    clientForm
  );
};
